import { FC, useCallback, useRef } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import style from "./style.module.scss";
import { callback, getAssetsAnimation } from "@views/thinking-layout-editor/utilities";

export interface LogoButtonProps {
  onClick?: () => void;
}

const LogoButton: FC<LogoButtonProps> = ({ onClick = callback }) => {
  const playerRef = useRef<Player>(null);

  const handlePlayerClick = useCallback(() => {
    const player = playerRef.current;
    if (!player) {
      return;
    }
    player.setSeeker(0, true);
    player.play();
    onClick();
  }, [onClick]);

  return (
    <div className={style.logoButton} onClick={handlePlayerClick}>
      <div className={style.content}>
        <Player ref={playerRef} keepLastFrame={true} autoplay src={getAssetsAnimation("logo-button.json")} />
      </div>
    </div>
  );
};

export default LogoButton;
